
import "../DropdownBase/DropdownBase.st.css.js";
import "../Foundation/stylable/colors.st.css.js";
import { classesRuntime, statesRuntime } from "./../stylable-esm-runtime.js";



var _namespace_ = "wds_1_76_1_InputWithOptions";
var _style_ = /*#__PURE__*/ classesRuntime.bind(null, _namespace_);

export var cssStates = /*#__PURE__*/ statesRuntime.bind(null, _namespace_);
export var style = /*#__PURE__*/ _style_;
export var st = /*#__PURE__*/ _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_76_1_InputWithOptions__root","nativeSelectWrapper":"wds_1_76_1_InputWithOptions__nativeSelectWrapper","nativeSelect":"wds_1_76_1_InputWithOptions__nativeSelect","nativeOption":"wds_1_76_1_InputWithOptions__nativeOption"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {"focusBoxShadow":"0 0 0 3px var(--wsr-color-F00, #AADBFC)"}; 
export var vars = {}; 




